import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import Navigation from './navigation.jsx';
import Header from './header.jsx';
function BuyersGuide() {
  const data = _THULEDATA._buyersGuide;
  useEffect(() => {
    setupProductListForDealerBuyersGuide();
  }, []);
  const setupProductListForDealerBuyersGuide = () => {
    const productListItems = document.querySelectorAll('.product-list-container .product-list-item');
    if (window.location.search?.indexOf('dbg_sc') === -1) {
      document.querySelector('.resultarea')?.classList.add('d-none');
    }
    productListItems?.forEach((item) => {
      const productlinks = item.querySelectorAll('.product-link');
      productlinks.forEach((x) => {
        x.removeAttribute('href');
        const title = x.querySelector('.product-item-name');
        if (title) title.style.cursor = 'default';
      });

      item.querySelector('.product-image .arrow.frg-icon-Arrow-long')?.classList.add('d-none');
      item.querySelector('.review-container')?.classList.add('d-none');
      item.querySelector('.color-selector-container .color-selector .list-inline')?.classList.add('d-none');
      item.querySelector('.tpd-product-stock-status')?.classList.add('d-none');

      if (!data.ShowPrice) item.querySelector('.price-container')?.classList.add('d-none');
      // Service Part Repair products are only buyable by service-repair centers.
      const isServicePartRepair = item.querySelector('.atc-service-part-repair')?.value === 'true';
      let isServiceRepairCenter = false;
      try {
        isServiceRepairCenter =
          JSON.parse(localStorage.getItem('extranetUser'))?.CurrentSelectedRetailer?.IsServiceRepairCenter === true;
      } catch {
        /* no extranet user available */
      }
      if (data.ShowAddToCartButton && (!isServicePartRepair || isServiceRepairCenter)) {
        let dbg__cartBtnContainer = item.querySelector('.dbg__cartBtnContainer');
        if (dbg__cartBtnContainer && !_THULEDATA?.FitAssistant) {
          dbg__cartBtnContainer.classList.remove('d-none');
          item.querySelector('.buyable-btn-section').classList.remove('d-none');
        }
      }
    });
  };
  return (
    <div id="buyersGuide">
      {data && (
        <>
          <Header configuration={data} />
          <Navigation categories={data.Categories} />
        </>
      )}
    </div>
  );
}
const rootElement = document.getElementById('REACT_buyersguide');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <Sentry.ErrorBoundary>
      <BuyersGuide />
    </Sentry.ErrorBoundary>
  );
}
